type TClassValue = string | undefined | false | TClassValue[] | { [key: string]: unknown };

/**
 * 合并 className 字符串，支持多种输入类型，包括字符串、数组和对象。
 *
 * 会过滤掉 falsy 值（如 undefined、false 等），并将有效的 className 合并为一个字符串。
 *
 * 参考了 clsx
 * @param classes - 多个 className 值
 * @returns 合并后的 className 字符串
 */
export const classNames = (...classes: TClassValue[]) => {
  const result: string[] = [];

  for (const cls of classes) {
    if (!cls) continue;

    if (typeof cls === 'string') {
      if (cls) {
        result.push(cls.trim());
      }
    } else if (Array.isArray(cls)) {
      const nested = classNames(...cls);
      if (nested) {
        result.push(nested);
      }
    } else if (typeof cls === 'object') {
      for (const [key, value] of Object.entries(cls)) {
        if (value) {
          result.push(key.trim());
        }
      }
    }
  }
  return result.join(' ');
};
